import { getUrlQuery } from '@/common/utils';

const noop = () => {};
const LXAnalytics = (window as any).LXAnalytics || noop;
const lxCommonParams = {}; // lx 通用字段，需要业务自己处理

class Analytics {
  constructor() {
    LXAnalytics('config', 'onWebviewAppearAutoPV', false);
  }

  pv(cid: string, params = {} as any) {
    const urlQuery = getUrlQuery();
    const from = (urlQuery && urlQuery.from) || (urlQuery && urlQuery.utm_source) || '-999';
    const valLab = {
      ...lxCommonParams,
      ...params,
      ...{
        from,
        themeConfigKey_id: (window as any).themeConfigKey
      }
    };
    const environment = {};
    LXAnalytics('pageView', { custom: { ...valLab } }, environment, cid);
  }

  mc(bid: string, params = {} as any, _options = {} as any, needTag = false) {
    const urlQuery = getUrlQuery();
    const from = (urlQuery && urlQuery.from) || (urlQuery && urlQuery.utm_source) || '-999';
    const options = {
      ...lxCommonParams,
      ..._options
    };
    const valLab = {
      ...lxCommonParams,
      ...params,
      ...{
        from,
        themeConfigKey_id: (window as any).themeConfigKey
      }
    };
    if (needTag) {
      LXAnalytics('tag', 'fsp_dcep', {
        [_options.cid]: {
          ...options,
          ...valLab,
          bid
        }
      });
    }
    LXAnalytics('moduleClick', bid, valLab, options);
  }

  mv(bid: string, params = {} as any, _options = {} as any) {
    const urlQuery = getUrlQuery();
    const from = (urlQuery && urlQuery.from) || (urlQuery && urlQuery.utm_source) || '-999';
    const options = {
      ...lxCommonParams,
      ..._options
    };
    const valLab = {
      ...lxCommonParams,
      ...params,
      ...{
        from,
        themeConfigKey_id: (window as any).themeConfigKey
      }
    };
    LXAnalytics('moduleView', bid, valLab, options);
  }

  addTag(tagObj: any) {
    LXAnalytics('tag', 'fsp_dcep', tagObj);
  }
}

const lx = new Analytics();

export {
  lx
};
